module.exports = __webpack_public_path__ + "static/media/video.e2c10bce.jpg";